import { apiKeys } from "../../app/services/apiKeys";
import { Tracking as SharedTracking } from "../shared/Tracking";

export const Tracking = () => (
  <SharedTracking
    didomiApiKey={apiKeys.value.didomi}
    gtmApiKey={apiKeys.value.gtm}
  />
);
